import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Components/Header";
import AboutUs from "../Components/AboutUs";
import OurServices from "../Components/OurServices";
import OurTeam from "../Components/OurTeam";
import WhereToFindUs from "../Components/WhereToFindUs";
import Testimonials from "../Components/Testimonials";

export const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Extract scrollTo parameter from query string
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo");
    
    // Check sessionStorage for stored section to scroll to
    const storedScrollSection = sessionStorage.getItem('scrollToSection');
    
    // Use either the URL parameter or sessionStorage value
    const targetSection = scrollTo || storedScrollSection;
    
    if (targetSection) {
      // Delay scrolling slightly to ensure components are loaded
      setTimeout(() => {
        const element = document.getElementById(targetSection);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          // Clear the sessionStorage after scrolling
          if (storedScrollSection) {
            sessionStorage.removeItem('scrollToSection');
          }
        }
      }, 500);
    }
  }, [location]);

  return (
    <>
      <Header />
      <AboutUs />
      <WhereToFindUs />
      <OurServices />
      <OurTeam />
      <Testimonials />
    </>
  );
};
